import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { AssemblyWithChildren, JobStatusSchema, PartTypeSchema } from "shared";

export const hasPredictionErrorForOneChild = (
  children: AssemblyWithChildren<QuoteRequestLineDto>[],
): boolean => {
  return children.some(
    (child) => child.quoteRequestLine.predictionStatus === JobStatusSchema.enum.ERROR,
  );
};

export const hasPredictionMissingForOneChild = (
  children: AssemblyWithChildren<QuoteRequestLineDto>[],
): boolean => {
  return children.some(
    (child) =>
      child.quoteRequestLine.predictionStatus === null &&
      child.quoteRequestLine.part.type !== PartTypeSchema.enum.CONSUMABLE,
  );
};
